export const SORT_BY_DIRECTION = ['asc', 'desc'] as const;
export type SortDirection = 'asc' | 'desc';

export const SORT_BY_VALUES = [
  'name',
  'rooms',
  'area',
  'price',
  'createdAt',
  'updatedAt',
  'creator',
] as const;
export type SortByValues = (typeof SORT_BY_VALUES)[number];
